/**
 * Fast numeric hash function for strings and numbers
 * Used for generating numeric identifiers (e.g., color selection, animation delays)
 */
export const hash = (s?: string | number | null) => {
  if (s == null) return 0
  if (typeof s === 'number') return s
  let hash = 0
  for (let i = 0; i < s.length; i++) {
    const chr = s.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return Math.abs(hash)
}

const enc = new TextEncoder()

export const arrayBufferToHex = (buffer: ArrayBuffer) =>
  [...new Uint8Array(buffer)].map(b => b.toString(16).padStart(2, '0')).join('')

export async function sha256(message: string): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-256', enc.encode(message))
  return arrayBufferToHex(hashBuffer)
}
